export { type ORSResponse, fetchObjectsFromUrls } from './object-resolver-service';
